var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "balance-sheet-table-row" }, [
    _c(
      "th",
      {
        class: [
          {
            bold: _vm.isBold,
            larger: "isLarger",
            "indent-5": _vm.hasSmallIndent,
            "indent-10": _vm.hasMediumIndent
          },
          "row-heading"
        ]
      },
      [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.name)))])]
    ),
    _vm._v(" "),
    _vm.isDisabled
      ? _c(
          "td",
          {
            staticClass: "disabled computed-cell right",
            class: { bold: _vm.isBold, larger: _vm.isLarger }
          },
          [_c("span", [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.item.value)))])]
        )
      : _c(
          "td",
          { staticClass: "input-cell" },
          [
            _c("numeric-input-control", {
              attrs: {
                minValue: -1000000000,
                disabled: _vm.isReadOnly,
                placeholderKey: "EnterValue",
                required: true,
                labelledBy: _vm.labelledBy
              },
              model: {
                value: _vm.item.value,
                callback: function($$v) {
                  _vm.$set(_vm.item, "value", $$v)
                },
                expression: "item.value"
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }